import React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { useResponsiveGridItemStyles } from './ResponsiveGrid.styles';

type StylesKey = keyof ReturnType<typeof useResponsiveGridItemStyles>;

export type ColumnSpan = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface GridItemSpans {
    span?: ColumnSpan;
    tabletSpan?: ColumnSpan;
    desktopSpan?: ColumnSpan;
    wideSpan?: ColumnSpan;
}

export interface GridItemProps extends GridItemSpans {
    children: React.ReactNode;
    className?: string;
}

export const ResponsiveGridItem: React.FC<GridItemProps> = ({
    children,
    span = 12,
    tabletSpan,
    desktopSpan,
    wideSpan,
    className,
}) => {
    const styles = useResponsiveGridItemStyles();

    const tabletSpanVal = tabletSpan || span;
    const desktopSpanVal = desktopSpan || tabletSpanVal;
    const wideSpanVal = wideSpan || desktopSpanVal;

    const classNames = mergeClasses(
        styles.root,
        styles[`span-${span}` as StylesKey],
        styles[`tablet-span-${tabletSpanVal}`],
        styles[`desktop-span-${desktopSpanVal}`],
        styles[`wide-span-${wideSpanVal}`],
        className
    );

    return <div className={classNames}>{children}</div>;
};
